var THRESHOLD = 116;
export var isElementLowerThanThreshold = function isElementLowerThanThreshold() {
  var refererElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THRESHOLD;
  try {
    if (refererElement === null) throw 'All params for hideElementMoreThresholdHeight are mandatory';
    var refererElementHeight = refererElement ? refererElement.scrollHeight : 0;
    return refererElementHeight <= threshold;
  } catch (e) {
    throw new Error("error : ".concat(e));
  }
};